const forms = document.querySelectorAll('form');
forms.forEach((form) => {
  const successBlock = form?.nextElementSibling;
  const inputName = form.querySelector('.input--name') as HTMLInputElement;
  const inputEmail = form.querySelector('.input--email') as HTMLInputElement;
  const checkBox = form.querySelector('.confirm__input') as HTMLInputElement;
  inputName?.addEventListener('input', () => {
    validationName(inputName);
  });
  inputEmail?.addEventListener('input', () => {
    validationEmail(inputEmail);
  });
  checkBox?.addEventListener('change', () => {
    validationCheckbox(checkBox);
  });
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    validationName(inputName);
    validationEmail(inputEmail);
    validationCheckbox(checkBox);
    if (validationName(inputName) && validationEmail(inputEmail) && validationCheckbox(checkBox)) {
      const url = '/ajax/forms/subscribe.php';
      try {
        const FormData = {
          name: inputName.value,
          email: inputEmail.value,
        };
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(FormData),
        });

        if (response.ok) {
          const data = await response.json();
          console.log(data);

          if (data.success) {
            successBlock?.classList.remove('hidden');
            form.classList.add('hidden');
          }
        } else {
          console.error(`HTTP error! Status: ${response.status}`);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }
  });
});
function validationName(input: any) {
  if (checkEmptyValue(input.value) && checkSpaces(input.value) && nameSymbols(input.value)) {
    input.classList.remove('input--error');
    return true;
  }
  input.classList.add('input--error');
}
function validationEmail(input: any) {
  if (checkEmptyValue(input.value) && checkSpaces(input.value) && checkEmail(input.value)) {
    input.classList.remove('input--error');
    return true;
  }
  input.classList.add('input--error');
}
function validationCheckbox(input: any) {
  if (checkCheckbox(input.checked)) {
    input.classList.remove('input--error');
    return true;
  } else input.classList.add('input--error');
}
const inputs = document.querySelectorAll('.input');
inputs.forEach((input: any) => {
  const inputBlock = input.closest('.input-block');
  const placeholder = inputBlock?.querySelector('.placeholder');
  window.addEventListener('load', () => {
    if (input.value.trim() !== '') {
      placeholder?.classList.add('placeholder--focus');
    }
  });
  input.addEventListener('focus', () => {
    placeholder?.classList.add('placeholder--focus');
  });
  input.addEventListener('blur', () => {
    if (input.value.trim() !== '') {
      return;
    }
    placeholder?.classList.remove('placeholder--focus');
  });
});

function checkEmptyValue(value: string) {
  if (value.trim() === '') {
    return false;
  }
  return true;
}

function checkSpaces(value: any) {
  return !/^\s|\s$/.test(value);
}
function nameSymbols(value: any) {
  return /^[а-яА-ЯёЁa-zA-Z\s]+$/i.test(value);
}
function checkEmail(value: any) {
  return /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu.test(
    value
  );
}
function checkCheckbox(value: any) {
  if (!value) {
    return false;
  }
  return true;
}

const modalSearchFormElement = document.querySelector('.modal--search-form');
const inputSearchFormElement = modalSearchFormElement?.querySelector('#search') as HTMLInputElement;
const buttonSearchFormElement = modalSearchFormElement?.querySelector('button');

buttonSearchFormElement?.addEventListener('click', () => {
  const newUrl = `${window.location.origin}/search/?q=${encodeURI(inputSearchFormElement?.value)}`;
  window.location.href = newUrl;
});
